.wrap {
	position: relative;
	display: flex;
	align-items: center;
}

.icon {
	position: absolute;
	left: var(--space-3);
	color: var(--ink-muted);
	pointer-events: none;
}

.input {
	width: 100%;
	padding: var(--space-3);
	/* Room for the leading icon and trailing clear button. */
	padding-left: calc(var(--space-3) + 18px + var(--space-2));
	padding-right: calc(var(--space-3) + 28px);
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-input);
	color: var(--ink);
	font: inherit;
}

.input:focus {
	outline: 2px solid var(--accent-sage);
	outline-offset: 1px;
}

/* Suppress the native WebKit clear affordance — we render our own. */
.input::-webkit-search-cancel-button {
	-webkit-appearance: none;
	appearance: none;
}

.clear {
	position: absolute;
	right: var(--space-2);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border: none;
	border-radius: 999px;
	background: none;
	color: var(--ink-muted);
	cursor: pointer;
}

.clear:hover {
	color: var(--ink);
}
